import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {RootState} from 'modules';
import {
  initializeAction,
  initInfoListAction,
  initListsAction,
} from 'modules/cut';
import {IVodInfoData} from 'lib/api/vodInfo';
import {setClickLog} from 'lib/utils';
// import { getSectionPlay } from "lib/playUtils";
import EditArea from 'components/edit/EditArea';

/**
 * 편집 영역 템플릿 컨테이너
 */

const EditAreaContainer = () => {
  const dispatch = useDispatch();
  const {vodData, fileList, cut, sectionLists, editMode} = useSelector(
    ({vodInfo, file, cut, timeline, ui}: RootState) => ({
      vodData: vodInfo.titleFileInfo.data,
      fileList: file.list,
      cut,
      sectionLists: timeline.sectionLists,
      editMode: ui.editMode,
    }),
  );
  const [editStatus, setEditStatus] = useState('vod_ctrl_close');
  const [clearBtn, setClearBtn] = useState('btn_disabled');

  /**
   * 컷 편집 상태
   */
  useEffect(() => {
    if (cut.status) {
      // 컷 편집 중
      setEditStatus(''); // 종료 버튼 활성화

      if (cut.lists.length <= 1 && cut.lists[0][0].duration === 0) {
        // 컷 편집 처음 눌렀을 경우 = 편집 리스트 없을 경우(초기화 상태인 경우)
        setClearBtn('btn_disabled'); // 초기화 버튼 비활성화

        if (cut.lists[0][0].endTime === 0) {
          // 섹션 1개인 파일일 때 편집 버튼 누를 시, 무한루프로 아래 dispatch해서 endTime=0 즉, 최초 컷 편집 실행 및 초기화 일 때만 아래 dispatch함
          dispatch(initInfoListAction(sectionLists, fileList));
          if (editMode === 'section') {
            dispatch(initListsAction(sectionLists));
          }
        }
      } else {
        setClearBtn(''); // 초기화 버튼 활성화
      }
    } else {
      // 컷 편집 종료
      setEditStatus('vod_ctrl_close'); // 종료 버튼 비활성화
      setClearBtn('btn_disabled'); // 초기화 버튼 비활성화
    }
  }, [cut.status, cut.lists]);

  /**
   * 초기화 버튼 클릭 함수
   */
  const onInitialClick = () => {
    dispatch(initializeAction());
    // dispatch(setStatusCutAction(true));

    if (!vodData) return;
    const {response} = vodData as IVodInfoData;
    if (!response.info) return;

    const {title_no} = response.info;
    let clickLogParam = `button_type=init&title_no=${title_no}`;
    if (editMode !== 'section') {
      clickLogParam += `&editor_type=${editMode}_editor`;
    }
    setClickLog(clickLogParam); // 클릭 로그
  };

  return (
    <EditArea
      editStatus={editStatus}
      clearBtn={clearBtn}
      onInitialClick={onInitialClick}
    />
  );
};

export default EditAreaContainer;
